import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import api from "../api/api";

const DeliveryUpdate = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem('isLoggedIn');
    sessionStorage.removeItem('username');
    navigate('/');
  };

  const [showDeliverySection, setShowDeliverySection] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dpName, setDpName] = useState('');
  const [reportDate, setReportDate] = useState('');

  const [itemTypes, setItemTypes] = useState([]);
  const [reportTypes, setReportTypes] = useState([]);

  const [deliveryList, setDeliveryList] = useState([]);
  const [tripStatuses, setTripStatuses] = useState([]);

  const [billCollectionList, setBillCollectionList] = useState([]);

  const [editedBills, setEditedBills] = useState({});

  const [vehicleList, setVehicleList] = useState([]);
  const [editedVehicles, setEditedVehicles] = useState({});

  const [billSearch, setBillSearch] = useState("");

  const [billLoading, setBillLoading] = useState(false);

  const [editedExpenses, setEditedExpenses] = useState({});
  const [editedStatuses, setEditedStatuses] = useState({});


const [reportSearch, setReportSearch] = useState("");
const [itemSearch, setItemSearch] = useState("");


const [showReportDropdown, setShowReportDropdown] = useState(false);
const [showItemDropdown, setShowItemDropdown] = useState(false);

const listRefReportType = useRef(null);
const listRefItemType = useRef(null);


  const [selectedItemType, setSelectedItemType] = useState("");
  const [selectedReportType, setSelectedReportType] = useState("");

  const [activeIndexReportType, setActiveIndexReportType] = useState(-1);
  const [activeIndexItemType, setActiveIndexItemType] = useState(-1);

  const tdClass =
    "px-4 py-3 border border-gray-200 text-sm text-gray-900 whitespace-nowrap align-middle";

  const inputClass =
    "w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-orange-400";


  useEffect(() => {
    if (!modalOpen) return;

    const handleEsc = (e) => {
      if (e.key === "Escape") {
        closeBill();
      }
    };

    window.addEventListener("keydown", handleEsc);

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [modalOpen]);


  useEffect(() => {
    if (modalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => (document.body.style.overflow = "auto");
  }, [modalOpen]);


  useEffect(() => {
    const d = new Date();
    setReportDate(
      `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`
    );

    loadDropdowns();
  }, []);

  // Auto scroll for report type dropdown
  useEffect(() => {
    if (listRefReportType.current && activeIndexReportType >= 0) {
      const item = listRefReportType.current.children[activeIndexReportType];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexReportType]);

  // Auto scroll for item type dropdown
  useEffect(() => {
    if (listRefItemType.current && activeIndexItemType >= 0) {
      const item = listRefItemType.current.children[activeIndexItemType];
      item?.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndexItemType]);

  const updateBillField = (seqId, field, value) => {
    setEditedBills(prev => ({
      ...prev,
      [seqId]: {
        ...prev[seqId],
        [field]: value
      }
    }));
  };



  const showDelivery = async () => {
    try {
      const res = await api.DeliveryUpdateItemAPI(
        username,
        selectedItemType,
        reportDate
      );

      console.log("DELIVERY LIST 👉", res);

      const tableData = res?.DeliveryUpdateItemAPIjs?.Table || [];

      setDeliveryList(tableData);
      setShowDeliverySection(true);
    } catch (err) {
      console.error("Delivery list error", err);
    }
  };


  const openBill = async (dpname, dhid) => {
    try {
      setEditedBills({});
      setDpName(dpname);
      setModalOpen(true);
      setBillCollectionList([]); // reset old data
      setBillLoading(true);

      const payload = { Dhid: dhid };

      const res = await api.DeliveryBillCollectionAPI(payload);

      console.log("BILL COLLECTION 👉", res);

      const tableData =
        res?.DeliveryBillCollectionAPIjs?.Table || [];

      setBillCollectionList(tableData);
    } catch (err) {
      console.error("Bill collection error", err);
    } finally {
      setBillLoading(false);  // 👈 STOP LOADING
    }
  };


  const closeBill = async () => {
    setModalOpen(false);

    // Refresh the delivery list after closing the modal
    try {
      const res = await api.DeliveryUpdateItemAPI(
        username,
        selectedItemType,
        reportDate
      );

      const tableData = res?.DeliveryUpdateItemAPIjs?.Table || [];
      setDeliveryList(tableData);
      setShowDeliverySection(true);
    } catch (err) {
      console.error("Error refreshing delivery list", err);
    }
  };


  const updateBillRow = async (row) => {
    try {
      const editedRow = editedBills[row.SeqId] || {};

      const payload = {
        Dhid: row.Dhid,
        SeqId: row.SeqId,
        Paymode: row.Paymode,
        TransactionNo: editedRow.TransactionNo ?? row.TransactionNo ?? "",
        PaidAmount: Number(editedRow.PaidAmount ?? row.PaidAmount ?? 0),
        DeliveryTimeRemark:
          editedRow.DeliveryTimeRemark ?? row.DeliveryTimeRemark ?? "-"
      };

      if (!payload.SeqId) {
        alert("Cannot update: SeqId is missing");
        return;
      }

      const res = await api.DeliveryReceiptBillUpdateAPI(payload);
      const result = res?.DeliveryReceiptBillUpdateAPIjs?.Table?.[0]?.Result;

      if (result) alert(result);

      openBill(dpName, row.Dhid);

    } catch (err) {
      console.error("Error updating bill:", err);
      alert("Failed to update bill.");
    }
  };


  const username = sessionStorage.getItem("username") || "UnknownUser";

  const loadDropdowns = async () => {
    try {
      // ✅ use your API wrapper method
      const res = await api.DeliverySheetUpdateItemAPI(username);

      console.log("API RESPONSE 👉", res);

      const data = res?.DeliverySheetUpdateItemAPIjs;

      setItemTypes(data?.Table || []);
      setVehicleList(data?.Table1 || []);
      setTripStatuses(data?.Table2 || []);
      setReportTypes(data?.Table3 || []);

      if (data?.Table?.length > 0) {
        setSelectedItemType(data.Table[0].ItemType);
      }

      if (data?.Table3?.length > 0) {
        setSelectedReportType(data.Table3[0].ReportTitle);
      }
    } catch (err) {
      console.error("Dropdown API Error", err);
    }
  };

  const normalizeStatus = (status) => {
    if (!status) return "";
    return status === "Closed" ? "Close" : status;
  };

  const updateAllDelivery = async () => {
    try {
      if (deliveryList.length === 0) {
        alert("No delivery data to update!");
        return;
      }

      const items = deliveryList.map((row) => ({
        Slno: row.Slno,
        Dhid: row.Dhid,
        Dpname: row.Dpname,
        NoOfBills: row.NoOfBills,
        TotalValue: Number(row.TotalValue ?? 0),
        otp: row.otp ?? 0,
        CashReceipt: Number(row.CashReceipt ?? 0),
        expense: Number(editedExpenses[row.Dhid] ?? row.expense ?? 0),
        VehicleNo: editedVehicles[row.Dhid] ?? row.VehicleNo ?? "-",
        TripStatus: editedStatuses[row.Dhid] ?? row.TripStatus ?? "",
        DeliveredBalance: row.DeliveredBalance ?? 0
      }));

      const payload = {
        User: username,
        SesId: new Date().getTime(), // example session id, replace if needed
        Items: items
      };

      const res = await api.UpdateDheadAPI(payload);

      console.log("UpdateDheadAPI response:", res);

      alert("Delivery data updated successfully!");
    } catch (err) {
      console.error("Error updating delivery data:", err);
      alert("Failed to update delivery data. Please try again.");
    }
  };

  const td =
  "px-3 py-2 border-b border-gray-200 text-gray-800 text-xs whitespace-nowrap align-middle";

const input =
  "w-full px-2 py-1 border border-gray-300 rounded-md text-xs bg-white \
   focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400";

  const handleKeyDownReportType = (e) => {
    const options = reportTypes.filter(r =>
      r.ReportTitle?.toLowerCase().includes(reportSearch.toLowerCase())
    );
    if (!showReportDropdown && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setShowReportDropdown(true);
      setActiveIndexReportType(0);
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndexReportType(i => i < options.length - 1 ? i + 1 : 0);
        break;
      case "ArrowUp":
        e.preventDefault();
        setActiveIndexReportType(i => i > 0 ? i - 1 : options.length - 1);
        break;
      case "Enter":
        if (showReportDropdown && activeIndexReportType >= 0) {
          e.preventDefault();
          const selected = options[activeIndexReportType];
          if (selected) {
            setSelectedReportType(selected.ReportTitle);
            setReportSearch(selected.ReportTitle);
            setShowReportDropdown(false);
            setActiveIndexReportType(-1);
          }
        }
        break;
      case "Escape":
        setShowReportDropdown(false);
        setActiveIndexReportType(-1);
        break;
      default:
        break;
    }
  };

  const handleKeyDownItemType = (e) => {
    const options = itemTypes.filter(it =>
      it.ItemType?.toLowerCase().includes(itemSearch.toLowerCase())
    );
    if (!showItemDropdown && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      setShowItemDropdown(true);
      setActiveIndexItemType(0);
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndexItemType(i => i < options.length - 1 ? i + 1 : 0);
        break;
      case "ArrowUp":
        e.preventDefault();
        setActiveIndexItemType(i => i > 0 ? i - 1 : options.length - 1);
        break;
      case "Enter":
        if (showItemDropdown && activeIndexItemType >= 0) {
          e.preventDefault();
          const selected = options[activeIndexItemType];
          if (selected) {
            setSelectedItemType(selected.ItemType);
            setItemSearch(selected.ItemType);
            setShowItemDropdown(false);
            setActiveIndexItemType(-1);
          }
        }
        break;
      case "Escape":
        setShowItemDropdown(false);
        setActiveIndexItemType(-1);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <Header onLogout={handleLogout} />
      <div className="p-3 bg-gray-50 min-h-screen [font-family:'Inter',sans-serif] md:ml-64">
        <div>
        <div className="flex items-center mb-6">
          <button
          
             onClick={() => navigate('/dashboard')}
            className="inline-flex items-center justify-center px-3 py-1 font-semibold text-gray-800 transition bg-gray-200 rounded-full shadow-md hover:bg-gray-300"
          >
            ← Back
          </button>

          <h2 className="text-2xl font-bold text-orange-600 text-center flex-1">
            Delivery Update
          </h2>

          <div className="flex gap-2">
            <button
              className="bg-orange-500 text-white px-3 py-1 rounded-full hover:bg-orange-600 transition font-semibold"
              onClick={updateAllDelivery} // ✅ call API here
            >
              Update
            </button>

            <button 
            onClick={() => navigate('/dashboard')}
            className="bg-orange-500 text-white px-3 py-1 rounded-full hover:bg-orange-600 transition font-semibold">
              Close
            </button>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-1 mb-2">
          <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-4 items-end">
            <div className="flex flex-col gap-1">
              <label className="text-sm font-bold text-orange-600">Date</label>
              <input
                type="date"
                className="w-full px-3 py-2 border border-orange-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                value={reportDate}
                onChange={(e) => setReportDate(e.target.value)}
              />
            </div>

           {/* REPORT TYPE SEARCH DROPDOWN */}
<div className="flex flex-col gap-1 relative">
  <label className="text-sm font-bold text-orange-600">
    Report Type
  </label>

  <input
    type="text"
    placeholder="Search Report Type"
    value={reportSearch}
    onFocus={() => setShowReportDropdown(true)}
    onChange={(e) => {
      setReportSearch(e.target.value);
      setSelectedReportType("");
      setShowReportDropdown(true);
      setActiveIndexReportType(-1);
    }}
    onBlur={() => setTimeout(() => setShowReportDropdown(false), 150)}
    onKeyDown={handleKeyDownReportType}
    className="w-full px-3 py-2 border border-orange-300 rounded-lg
               focus:outline-none focus:ring-2 focus:ring-orange-500"
  />

  {showReportDropdown && (
    <div ref={listRefReportType} className="absolute top-full mt-1 w-full bg-white border border-orange-300
                    rounded-lg shadow-lg max-h-40 overflow-y-auto z-50">
      {reportTypes
        .filter(r =>
          r.ReportTitle
            ?.toLowerCase()
            .includes(reportSearch.toLowerCase())
        )
        .map((r, i) => (
          <div
            key={i}
            onClick={() => {
              setSelectedReportType(r.ReportTitle);
              setReportSearch(r.ReportTitle);
              setShowReportDropdown(false);
              setActiveIndexReportType(-1);
            }}
            onMouseEnter={() => setActiveIndexReportType(i)}
            className={`px-3 py-2 cursor-pointer ${
              i === activeIndexReportType
                ? "bg-gray-100 font-semibold"
                : "hover:bg-orange-100"
            } text-sm`}
          >
            {r.ReportTitle}
          </div>
        ))}

      {reportTypes.filter(r =>
        r.ReportTitle?.toLowerCase().includes(reportSearch.toLowerCase())
      ).length === 0 && (
        <div className="px-3 py-2 text-gray-400 text-sm italic">
          No match found
        </div>
      )}
    </div>
  )}
</div>


         {/* ITEM TYPE SEARCH DROPDOWN */}
<div className="flex flex-col gap-1 relative">
  <label className="text-sm font-bold text-orange-600">
    Item Type
  </label>

  <input
    type="text"
    placeholder="Search Item Type"
    value={itemSearch}
    onFocus={() => setShowItemDropdown(true)}
    onChange={(e) => {
      setItemSearch(e.target.value);
      setSelectedItemType("");
      setShowItemDropdown(true);
      setActiveIndexItemType(-1);
    }}
    onBlur={() => setTimeout(() => setShowItemDropdown(false), 150)}
    onKeyDown={handleKeyDownItemType}
    className="w-full px-3 py-2 border border-orange-300 rounded-lg
               focus:outline-none focus:ring-2 focus:ring-orange-500"
  />

  {showItemDropdown && (
    <div ref={listRefItemType} className="absolute top-full mt-1 w-full bg-white border border-orange-300
                    rounded-lg shadow-lg max-h-40 overflow-y-auto z-50">
      {itemTypes
        .filter(it =>
          it.ItemType
            ?.toLowerCase()
            .includes(itemSearch.toLowerCase())
        )
        .map((it, i) => (
          <div
            key={i}
            onClick={() => {
              setSelectedItemType(it.ItemType);
              setItemSearch(it.ItemType);
              setShowItemDropdown(false);
              setActiveIndexItemType(-1);
            }}
            onMouseEnter={() => setActiveIndexItemType(i)}
            className={`px-3 py-2 cursor-pointer ${
              i === activeIndexItemType
                ? "bg-gray-100 font-semibold"
                : "hover:bg-orange-100"
            } text-sm`}
          >
            {it.ItemType}
          </div>
        ))}

      {itemTypes.filter(it =>
        it.ItemType?.toLowerCase().includes(itemSearch.toLowerCase())
      ).length === 0 && (
        <div className="px-3 py-2 text-gray-400 text-sm italic">
          No match found
        </div>
      )}
    </div>
  )}
</div>



            <div className="flex gap-2 lg:col-span-2">
              <button
                onClick={showDelivery}
                className="bg-orange-500 text-white px-3 py-1 rounded-full hover:bg-orange-600 transition font-semibold"
              >
                Refresh
              </button>

              <button className="bg-orange-500 text-white px-3 py-1 rounded-full hover:bg-orange-600 transition font-semibold">

                Preview
              </button>
            </div>
          </div>
        </div>

        {/* DELIVERY LIST */}
       {/* DELIVERY LIST */}
<div className="overflow-x-auto p-1 mb-6">
  <div className="min-w-full overflow-x-auto">
    <table className="min-w-[1400px] bg-white border-gray-300 rounded-2xl shadow-lg overflow-hidden text-xs">

            <thead className="bg-orange-500 text-white">
              <tr>
                <th className="px-2 py-2 text-center border-b whitespace-nowrap">Print</th>
                <th className="px-2 py-2 text-center border-b whitespace-nowrap">S.No</th>
                <th className="px-2 py-2 text-left border-b whitespace-nowrap">DP Name</th>
                <th className="px-2 py-2 text-center border-b whitespace-nowrap">Tot Bills</th>
                <th className="px-2 py-2 text-right border-b whitespace-nowrap">Tot Value</th>
                <th className="px-2 py-2 text-right border-b whitespace-nowrap">Cash</th>
                <th className="px-2 py-2 text-center border-b whitespace-nowrap">Delivered</th>
                <th className="px-2 py-2 text-center border-b whitespace-nowrap">Bal Delivery</th>
                <th className="px-2 py-2 text-center border-b whitespace-nowrap">Time</th>
                <th className="px-2 py-2 text-center border-b whitespace-nowrap">Expense</th>
                <th className="px-2 py-2 text-left border-b whitespace-nowrap">Vehicle</th>
                <th className="px-2 py-2 text-center border-b whitespace-nowrap">Status</th>
                <th className="px-2 py-2 text-center border-b whitespace-nowrap">Collect</th>
              </tr>
            </thead>
            <tbody>
              {!showDeliverySection ? (
                <tr>
                  <td colSpan="13" className="text-center p-4 text-gray-500">
                    Click Refresh to load data
                  </td>
                </tr>
              ) : deliveryList.length === 0 ? (
                <tr>
                  <td colSpan="13" className="text-center p-4 text-gray-500">
                    No data found
                  </td>
                </tr>
              ) : (
                deliveryList.map((row) => (
                  <tr key={row.Dhid} className="hover:bg-orange-50">
                    <td className="px-2 py-1 border-b text-center whitespace-nowrap">
                      <button className="bg-orange-500 text-white px-3 py-1 rounded-full hover:bg-orange-600 transition font-semibold">
                        Print
                      </button>
                    </td>

                    <td className="px-2 py-2 border-b text-black font-medium text-center whitespace-nowrap">{row.Slno}</td>

                    <td className="px-2 py-2 border-b text-black whitespace-nowrap">{row.Dpname}</td>

                    <td className="px-2 py-2 border-b text-black text-right whitespace-nowrap">{row.NoOfBills}</td>

                    <td className="px-2 py-2 border-b text-black text-right whitespace-nowrap">{row.TotalValue?.toFixed(2)}</td>

                    <td className="px-2 py-2 border-b text-black text-right whitespace-nowrap">{row.CashReceipt?.toFixed(2)}</td>

                    <td className="px-2 py-2 border-b text-black text-right whitespace-nowrap">{row.Delivered}</td>

                    <td className="px-2 py-2 border-b text-black text-right whitespace-nowrap">{row.DeliveredBalance}</td>

                    <td className="px-2 py-2 border-b text-black text-center whitespace-nowrap">{row.RecentTime ?? "-"}</td>

                    <td className="px-2 py-2 border-b text-right whitespace-nowrap">
                      <input
                        type="text"
                        inputMode="numeric"
                        maxLength={5}
                        className="px-2 py-1 border border-gray-300 rounded text-right w-16"
                        value={editedExpenses[row.Dhid] ?? row.expense ?? ""}
                        onChange={(e) =>
                          setEditedExpenses(prev => ({
                            ...prev,
                            [row.Dhid]: e.target.value.replace(/\D/g, "")
                          }))
                        }
                      />
                    </td>

                    <td className="px-2 py-2 border-b text-center whitespace-nowrap">
                      <select
                        className="px-2 py-1 border border-gray-300 rounded w-full text-center"
                        value={editedVehicles[row.Dhid] ?? row.VehicleNo ?? ""}
                        onChange={(e) =>
                          setEditedVehicles(prev => ({
                            ...prev,
                            [row.Dhid]: e.target.value
                          }))
                        }
                      >
                        <option value="">Select Vehicle</option>

                        {vehicleList.map((v, i) => (
                          <option key={i} value={v.VehicleNo}>
                            {v.VehicleNo}
                          </option>
                        ))}
                      </select>
                    </td>


                    <td className="px-2 py-2 border-b text-center whitespace-nowrap">
                      <select
                        className="px-2 py-1 border border-gray-300 rounded text-center w-full"
                        value={normalizeStatus(
                          editedStatuses[row.Dhid] ?? row.TripStatus
                        )}
                        onChange={(e) =>
                          setEditedStatuses(prev => ({
                            ...prev,
                            [row.Dhid]: e.target.value
                          }))
                        }
                      >
                        {tripStatuses.map((status, index) => (
                          <option key={index} value={status.TripStatus}>
                            {status.TripStatus}
                          </option>
                        ))}
                      </select>
                    </td>

                    <td className="px-2 py-2 border-b text-center whitespace-nowrap">
                      <button
                        className="bg-orange-500 text-white px-3 py-1 rounded-full hover:bg-orange-600 transition font-semibold"
                        onClick={() => openBill(row.Dpname, row.Dhid)}
                      >
                        Bill Collection
                      </button>

                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        </div>
      </div>

      {/* BILL COLLECTION MODAL */}
      {modalOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60">
         <div className="bg-white w-[95%] max-w-[1400px] h-[90vh] flex flex-col rounded-xl shadow-xl">
            {/* HEADER */}
            <div className="sticky top-0 z-10 flex items-center justify-between border-b px-5 py-3 bg-white">
              {/* LEFT */}
              <div></div>

              {/* CENTER */}
              <h3 className="font-semibold whitespace-nowrap text-center">
                Bill Collection –
                <span className="text-orange-500 ml-1">{dpName}</span>
              </h3>

              {/* RIGHT */}
              <div className="flex items-center gap-3">
                <input
                  type="text"
                  placeholder="Search by Code / Customer / Invoice No"
                  value={billSearch}
                  onChange={(e) => setBillSearch(e.target.value)}
                  className="w-[300px] px-3 py-2 border border-orange-500 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                />

                <button
                  onClick={closeBill}
                  className="text-3xl leading-none text-orange-500 hover:text-orange-600"
                >
                  ×
                </button>
              </div>
            </div>

            {/* BODY */}
            <div className="flex-1 overflow-hidden">
              <div className="h-full overflow-auto border border-orange-200 rounded-xl shadow-lg bg-white">

                <table className="min-w-[1600px] w-full border-collapse text-xs">


                  {/* TABLE HEAD */}
                 <thead className="sticky top-0 z-30 bg-gradient-to-r from-orange-500 to-orange-600">
  <tr>
    {[
      "Slno", "Code", "Customer", "Inv No", "Inv Date", "Net Total",
      "Balance", "Pay Mode", "Txn No", "Paid Amount",
      "Remarks", "Rid", "Update", "Status"
    ].map((h) => (
      <th
        key={h}
        className={`px-3 py-2 text-[11px] font-bold text-white uppercase tracking-wide
          ${["Net Total", "C Balance", "Paid Amt"].includes(h)
            ? "text-right"
            : "text-center"
          }`}
      >
        {h}
      </th>
    ))}
  </tr>
</thead>


                  {/* TABLE BODY */}
                 <tbody>
  {billLoading ? (
    <tr>
      <td colSpan="14" className="py-12 text-center font-semibold text-orange-500">
        ⏳ Loading bills, please wait...
      </td>
    </tr>
  ) : billCollectionList.length === 0 ? (
    <tr>
      <td colSpan="14" className="py-12 text-center text-gray-500 italic">
        No bill data found
      </td>
    </tr>
  ) : (
    billCollectionList
      .filter((row) => {
        if (!billSearch) return true;
        const s = billSearch.toLowerCase();
        return (
          row.Vcode?.toLowerCase().includes(s) ||
          row.VName?.toLowerCase().includes(s) ||
          row.InvNo?.toLowerCase().includes(s)
        );
      })
      .map((row, index) => (
        <tr
          key={row.SeqId}
          className={`transition
            ${index % 2 === 0 ? "bg-orange-50/40" : "bg-white"}
            hover:bg-orange-100`}
        >
          <td className={`${td} text-center`}>{row.Slno}</td>
          <td className={`${td} font-mono`}>{row.Vcode}</td>
          <td className={`${td} font-medium`}>{row.VName}</td>
          <td className={td}>{row.InvNo}</td>
          <td className={td}>{row.InvDate}</td>

          <td className={`${td} text-right font-semibold`}>
            ₹{row.Nettotal}
          </td>

          <td className={`${td} text-right font-semibold`}>
            ₹{row.CBalance}
          </td>

          <td className={`${td} text-center`}>
            <span className="px-2 py-[2px] rounded-full text-[10px] font-bold bg-green-100 text-green-800">
              {row.Paymode}
            </span>
          </td>

          <td className={td}>
            <input
              className={`${input} text-center`}
              value={editedBills[row.SeqId]?.TransactionNo ?? row.TransactionNo ?? ""}
              onChange={(e) =>
                updateBillField(row.SeqId, "TransactionNo", e.target.value)
              }
            />
          </td>

          <td className={`${td} text-right`}>
            <input
              className={`${input} w-[90px] text-right`}
              inputMode="numeric"
              value={editedBills[row.SeqId]?.PaidAmount ?? row.PaidAmount ?? ""}
              onChange={(e) =>
                updateBillField(
                  row.SeqId,
                  "PaidAmount",
                  e.target.value.replace(/\D/g, "")
                )
              }
            />
          </td>

          <td className={td}>
            <input
              className={input}
              value={
                editedBills[row.SeqId]?.DeliveryTimeRemark ??
                row.DeliveryTimeRemark ??
                ""
              }
              onChange={(e) =>
                updateBillField(row.SeqId, "DeliveryTimeRemark", e.target.value)
              }
            />
          </td>

          <td className={`${td} text-center font-semibold`}>
            {row.Rid}
          </td>

          <td className={`${td} text-center`}>
            <button
              onClick={() => updateBillRow(row)}
              className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-1
                         rounded-full font-bold shadow-md transition active:scale-95"
            >
              ⟳
            </button>
          </td>

          <td className={`${td} text-center`}>
            <span
              className={`px-2 py-[2px] rounded-full text-[10px] font-bold
                ${row.DeliveryStatus === "Delivered"
                  ? "bg-green-100 text-green-800"
                  : "bg-yellow-100 text-yellow-800"
                }`}
            >
              {row.DeliveryStatus}
            </span>
          </td>
        </tr>
      ))
  )}
</tbody>

                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default DeliveryUpdate;



